interface EventStreamOpts {
  url: string;
  onMessage: (data: string) => void;
  onOpen?: () => void;
  /** Abriu de novo depois de cair: quem escuta pode estar com número velho. */
  onReopen?: () => void;
  onError?: () => void;
}

/**
 * Assina um SSE e RECONECTA quando o navegador desiste.
 *
 * O `EventSource` só se reconecta sozinho quando a queda é de rede. Se a
 * resposta chega com status diferente de 200 — o 502 que o Caddy devolve
 * enquanto o container reinicia —, ele fecha de vez e nunca mais tenta: a tela
 * fica parada até um F5. Medido em 25/08/2026, 24 minutos sem uma recarga.
 */
export function connectEventStream(opts: EventStreamOpts): () => void {
  const RETRY_MS = 3_000;

  let source: EventSource | null = null;
  let retry: ReturnType<typeof setTimeout> | null = null;
  let closed = false;
  let opened = false;

  const open = (): void => {
    source = new EventSource(opts.url, { withCredentials: true });

    source.onopen = () => {
      opts.onOpen?.();
      if (opened) opts.onReopen?.();
      opened = true;
    };
    source.onmessage = (message) => opts.onMessage(message.data);
    source.onerror = () => {
      opts.onError?.();
      if (closed || source?.readyState !== EventSource.CLOSED) return;
      retry = setTimeout(open, RETRY_MS);
    };
  };

  open();

  return () => {
    closed = true;
    if (retry) clearTimeout(retry);
    source?.close();
  };
}
